module.exports = __webpack_public_path__ + "img/game_tiyu_bangqiu.83a5fb33.png";